import { jsx } from "react/jsx-runtime";
import { memo, forwardRef } from "react";
import { IconBase } from "src/components/ui/IconBase";
export default memo(forwardRef(function IconSvgSwitchMobile({
  className,
  "data-test-id": dataTest = "IconSwitchMobile",
  ...props
}, ref) {
  return /* @__PURE__ */ jsx(IconBase, { ...props, "data-test-id": dataTest, className, innerRef: ref, children: /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 14", style: {
    width: 24,
    height: 24
  }, children: /* @__PURE__ */ jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "m20 6 4 4-4 4-.7-.7 2.731-2.784H8v-1h14.031l-2.731-2.8L20 6ZM4.245 1.17 4.7.7 4 0l-.01.01-.457.457-.24.24L.707 3.293l-.223.223-.43.43L0 4l.054.054.462.462.191.191 2.586 2.586.24.24.456.456L4 8l.7-.7-.455-.47L2.97 5.517l-.97-1h14v-1H1.969l.97-1L4.245 1.17Z" }) }) });
}));
